import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/desktop/panther_2880x1064.webp")